import { Redirect } from 'react-router';
import { useSelector } from 'react-redux';
import NotFound from '../views/NotFound/NotFound';
import AcceptMembership from '../views/AcceptMembership/AcceptMembership';
import AllServices from '../views/AllServices/AllServices';
import ActivateAccount from '../views/Auth/ActivateAccount/ActivateAccount';
import Login from '../views/Auth/Login/Login';
import Register from '../views/Auth/Register/Register';
import RequestPassword from '../views/Auth/RequestPassword/RequestPassword';
import BaseLegal from '../views/BaseLegal/BaseLegal';
import FAQ from '../views/FAQ/FAQ';
import Contact from '../views/Contact/Contact';
import GeneralQueries from '../views/GeneralQueries/GeneralQueries';
import Home from '../views/Home/Home';
import ListOfServicesPerCategory from '../views/ListOfServicesPerCategory/ListOfServicesPerCategory';
import MobileValidation from '../views/MobileValidation/MobileValidation';
import { MyConfiguration } from '../views/MyConfiguration/MyConfiguration';
import MyDesk from '../views/MyDesk/MyDesk';
import MyDocumentsPage from '../views/MyDocumentsPage/MyDocumentsPage.jsx';
import { PolicyPrivacy } from '../views/PolicyPrivacy/PolicyPrivacy';
import RequestService from '../views/RequestService/RequestService';
import ServiceDescription from '../views/ServiceDescription/ServiceDescription';
import ServiceRequestedDetails from '../views/ServiceRequestedDetails/ServiceRequestedDetails';
import ValidatePayment from '../views/ValidatePayment/ValidatePayment';
import MyProfilePage from '../views/MyProfilePage/MyProfilePage';
import MessagesPage from '../views/MessagesPage/MessagesPage.jsx';
import HistoryPage from '../views/HistoryPage/HistoryPage.jsx';

const AppWildcardRedirect = () => {
    const { authenticated } = useSelector((state) => state.authReducer);
    if (authenticated) {
        return <Redirect to="/app/mi-escritorio" />;
    } else {
        return <Redirect to="/login" />;
    }
};

const routes = [
    //PUT ALL loginRequired:false OBJECTS ROUTES on TOP of array
    {
        path: '/',
        component: Home,
        exact: true,
        layout: '',
        loginRequired: false
    },
    {
        path: '/login',
        component: Login,
        exact: true,
        layout: '',
        loginRequired: false
    },
    {
        path: '/requestPassword',
        component: RequestPassword,
        exact: true,
        layout: '',
        loginRequired: false
    },
    {
        path: '',
        component: Register,
        exact: true,
        layout: '/registro',
        loginRequired: false
    },
    {
        path: '/mobileValidation',
        component: MobileValidation,
        exact: true,
        layout: '',
        loginRequired: false
    },
    /* 
   {  // FOR SEE ALL FORM FIELDS AND COMPONENTS ONLY DEVELOPMENT
     path: "/TESTFORM",
     component: ExampleAppForm,
     exact: true,
     layout: "/app",
     loginRequired: false,
   },
  */
    {
        path: '/activateAccount/:activationToken',
        component: ActivateAccount,
        exact: true,
        layout: '/app',
        loginRequired: false
    },
    {
        path: '/:slug',
        component: ServiceDescription,
        exact: true,
        layout: '/tramite',
        loginRequired: false
    },
    {
        path: '',
        component: AllServices,
        exact: true,
        layout: '/todos-los-tramites',
        loginRequired: false
    },
    {
        path: '/aceptar-membresia',
        component: AcceptMembership,
        exact: true,
        layout: '/app',
        loginRequired: false
    },
    {
        path: '',
        component: Contact,
        exact: true,
        layout: '/contacto',
        loginRequired: false
    },
    {
        path: '',
        component: BaseLegal,
        exact: true,
        layout: '/base-legal',
        loginRequired: false
    },
    {
        path: '',
        component: FAQ,
        exact: true,
        layout: '/preguntas-frecuentes',
        loginRequired: false
    },
    {
        path: '',
        component: GeneralQueries,
        exact: true,
        layout: '/consultas-generales',
        loginRequired: false
    },
    {
        path: '',
        component: PolicyPrivacy,
        exact: true,
        layout: '/politicas-de-privacidad',
        loginRequired: false
    },
    {
        path: '/mi-escritorio',
        component: MyDesk,
        exact: true,
        layout: '/app',
        loginRequired: true
    },
    {
        path: '/documentos',
        component: MyDocumentsPage,
        exact: true,
        layout: '/app',
        loginRequired: true
    },
    {
        path: '/perfil',
        component: MyProfilePage,
        exact: true,
        layout: '/app',
        loginRequired: true
    },
    {
        path: '/mensajes',
        component: MessagesPage,
        exact: true,
        layout: '/app',
        loginRequired: true
    },
    {
        path: '/historial',
        component: HistoryPage,
        exact: true,
        layout: '/app',
        loginRequired: true
    },
    {
        path: '/empresas',
        component: MyDesk,
        exact: true,
        layout: '/app',
        loginRequired: true
    },

    {
        path: '/mi-cuenta/:tab?',
        component: MyConfiguration,
        exact: true,
        layout: '/app',
        loginRequired: true
    },
    {
        path: '/:slug/:companyID?/:companyName?',
        component: RequestService,
        exact: true,
        layout: '/solicitar-tramite',
        loginRequired: true
    },
    {
        path: '/serviceRequestedDetails/:requestID',
        component: ServiceRequestedDetails,
        exact: true,
        layout: '/app',
        loginRequired: true
    },
    /* {
     path: "/requestedServicesList/:servicesStatus",
     component: RequestedServiceList,
     exact: true,
     layout: "/app",
     loginRequired: true,
   },
   */
    {
        path: '/validatePayment/:requestID',
        component: ValidatePayment,
        exact: false,
        layout: '/app',
        loginRequired: false
    },

    {
        path: '*',
        layout: '',
        component: NotFound
    },
    {
        path: '*',
        layout: '/app',
        component: AppWildcardRedirect
    },
    {
        path: '*',
        layout: '/tramite',
        component: NotFound
    },
    {
        path: '*',
        layout: '/todos-los-tramites',
        component: NotFound
    },
    {
        path: '*',
        layout: '/solicitar-tramite',
        component: NotFound
    },
    {
        path: '*',
        layout: '/registro',
        component: NotFound
    },
    {
        path: '*',
        layout: '/contacto',
        component: NotFound
    },
    {
        path: '*',
        layout: '/consultas-generales',
        component: NotFound
    },
    {
        path: '*',
        layout: '/politicas-de-privacidad',
        component: NotFound
    },
    {
        path: '*',
        layout: '/base-legal',
        component: NotFound
    }
];

export default routes;
